import React, { PureComponent } from 'react';
import {
  Box,
  Flex,
  HStack,
  Stack,
  Text,
  VStack,
  Button,
  Center,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Grid,
  GridItem,
  CircularProgress,
  CircularProgressLabel,
  ListItem,
  ListIcon,
  List
} from '@chakra-ui/react';

import { ChevronDownIcon } from '@chakra-ui/icons';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import ServerError from '../components/Error';
import MainContainer from '../components/MainContainer';
import StatisticsCards from '../components/StatisticsCards';
import EventsCalendar from '../components/events-calendar';
import Loader from '../components/loader/Loader';
import { useAppContext, useMe } from '../contexts/app-context';
import client from '../data/client';
import { useDepartments } from '../data/department';
import { useTranslate } from '../hooks/langs-hooks';
import { Id } from '../types';

import { LineChart, XAxis, CartesianGrid, Line, Legend, ResponsiveContainer, ComposedChart, Tooltip, Bar, PieChart, Pie, Cell, YAxis } from 'recharts';


//import "react-responsive-carousel/lib/styles/carousel.min.css";

import { MdCheckCircle, MdSettings } from 'react-icons/md';
import { getDeptKPI, getTasksAndProjects, usersCompletedTasks } from '../data/client/endpoints/user.endpoints';

const data1 = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const style = {
  top: '50%',
  right: 0,
  transform: 'translate(0, -50%)',
  lineHeight: '24px',
};


interface AdminDashboardProps {

}

const AdminDashboard: React.FC<AdminDashboardProps> = ({ }) => {
  const chart1Data: { name?: string; uv?: number; pv?: number; amt?: number }[] = [];
  const [kPI1Date, setKPI1Date] = useState(new Date());
  let [cdID, setcdID] = useState(new Number())
  const cid = useState(Number)
  const kpiQuery = useQuery({
    queryKey: ['dept-kpi', kPI1Date],
    queryFn: () => getTasksAndProjects(kPI1Date),
  });
  const kpiDeptQuery = useQuery({
    queryKey: ['deptAchievment-kpi', kPI1Date],
    queryFn: () => getDeptKPI(kPI1Date),
  });
  // const usertasks=usersCompletedTasks(cdID);

  const chart1DataDept: { name?: string; uv?: number; pv?: number }[] = [];

  const keys1 = kpiDeptQuery.data?.map((kbidept) => {
    debugger;
    chart1DataDept.push({
      name: kbidept.key,//t(keys[i]),
      pv: kbidept.lst,
      uv: kbidept.lst //kpiQuery.data![keys[i - 1] as 'jan'],
    })
  })
  const keys = kpiQuery.data?.map((kbi) => {
    chart1Data.push({
      name: kbi.month,//t(keys[i]),
      pv: kbi.countCompleteProj,
      uv: kbi.countCompleteTask,
      amt: kbi.countCompleteTask //kpiQuery.data![keys[i - 1] as 'jan'],
    })
  });

  const t = useTranslate();
  const me = useMe();
  const { branch } = useAppContext();
  const departmentsQuery = useDepartments();
  const [date, setDate] = useState(new Date(Date.now()));

  const data2 = [
    { name: 'Jan', value: 1 },
    { name: 'Feb', value: 2 },
    { name: 'Mar', value: 3 },
    { name: 'Aprial', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'Augest', value: 8 },
    { name: 'Sept', value: 9 },
    { name: 'Oct', value: 10 },
    { name: 'Nov', value: 11 },
    { name: 'Dec', value: 12 },

  ];
  const [selectedDepartmentId, setSelectedDepartmentId] = useState<Id | null>(
    null
  );

  useEffect(() => {
    if (departmentsQuery.data?.length) {
      setSelectedDepartmentId(departmentsQuery.data[0].departmentId);
    }
  }, [departmentsQuery.data]);
  // const userkbi = useQuery({
  //   queryKey: ['user-kpi',  cdID],
  //   queryFn: () => usersCompletedTasks( cdID),
  //   });
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['admin-dashboard', branch?.branchId, selectedDepartmentId],
    queryFn: () =>
      client.admin.statistics({
        branchId: branch?.branchId!,
        departmentId: selectedDepartmentId!,
      }),
    refetchOnMount: 'always',
    enabled: !!branch?.branchId && selectedDepartmentId != null,
  });




  return (
    <MainContainer py='7'>
      {/* alignItems={{base:'center',md:'center',lg:'normal',xl:'normal'}} */}
      <VStack alignItems={'flex-start'} color={'#010E40'} spacing={0} boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)' p={5}>
        <Text fontSize={'2rem'} fontWeight={'500'}>
          {t('admin-dashboard-header-1')}
        </Text>
        <Text color={'rgba(0, 0, 0, 0.44)'}>
          {t('admin-dashboard-header-2')}
        </Text>
      </VStack>

      {isLoading ? (
        <Loader />
      ) : isError ? (
        <ServerError error={error} />
      ) : (
        // <Stack direction={['column', null, 'row']}></Stack>
        <Stack direction={['column', null, 'row']}>
          <Box w='70%' pt='8rem'>
            <Box maxW='1000px' mx='auto'>
              <StatisticsCards />
            </Box>
            <Stack boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)' mb={4} p={5} bg='#fff' borderRadius={'1.25rem'}>
              <Text
                textTransform={'capitalize'}
                maxW='24.5rem'
                borderRadius={'1.25rem'}
                mb='3.5rem'
                fontWeight={1000}
                fontSize={'1.50rem'}
                color='black'
              >
                {t('Text-General-Statistics')}
              </Text>
              <Flex
                flexWrap={'wrap'}
                gap={3}
                alignItems={'center'}
                // px={[0, 0, '2rem']}
                justifyContent={'center'}
                mb={5}
              >
                <VStack>
                  <Center borderRadius={'4.125rem'} borderWidth={'0.2rem'} borderColor='blue' p={2}>
                    <svg width="82" height="84" viewBox="0 0 82 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M71.75 66.5H78.5833V73.5H3.41663V66.5H10.25V14C10.25 13.0717 10.6099 12.1815 11.2507 11.5251C11.8914 10.8687 12.7605 10.5 13.6666 10.5H47.8333C48.7395 10.5 49.6085 10.8687 50.2492 11.5251C50.89 12.1815 51.25 13.0717 51.25 14V66.5H64.9166V38.5H58.0833V31.5H68.3333C69.2395 31.5 70.1085 31.8687 70.7493 32.5251C71.39 33.1815 71.75 34.0717 71.75 35V66.5ZM17.0833 17.5V66.5H44.4166V17.5H17.0833ZM23.9166 38.5H37.5833V45.5H23.9166V38.5ZM23.9166 24.5H37.5833V31.5H23.9166V24.5Z" fill="#8C73EE" />
                    </svg>
                  </Center>
                  <Text
                    fontSize={'1.25rem'}
                    fontWeight={500}
                    color='blue'
                  >
                    {t('text-branches-count')}
                  </Text>
                  <Text
                    fontSize={'1.25rem'}
                    fontWeight={500}
                    color='blue'
                  >
                    {data.branchCount}
                  </Text>
                </VStack>




                <VStack>
                  <Center borderRadius={'5.125rem'} borderWidth={'0.2rem'} borderColor='blue' p={2}>
                    <svg width="82" height="84" viewBox="0 0 69 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M34.5 45.5C42.4391 45.5 48.875 37.665 48.875 28C48.875 18.335 42.4391 10.5 34.5 10.5C26.5609 10.5 20.125 18.335 20.125 28C20.125 37.665 26.5609 45.5 34.5 45.5Z" stroke="#8C73EE" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M57.5 73.5C57.5 66.0739 55.0768 58.952 50.7635 53.701C46.4501 48.45 40.6 45.5 34.5 45.5C28.4 45.5 22.5499 48.45 18.2365 53.701C13.9232 58.952 11.5 66.0739 11.5 73.5" stroke="#8C73EE" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </Center>
                  <Text
                    fontSize={'1.25rem'}
                    fontWeight={500}
                    color='blue'
                  >
                    {t('text-employees-count')}
                  </Text>
                  <Text
                    fontSize={'1.25rem'}
                    fontWeight={500}
                    color='blue'
                  >
                    {data.userCount}
                  </Text>
                </VStack>




                <VStack>
                  <Center borderRadius={'5.125rem'} borderWidth={'0.2rem'} borderColor='blue' p={2}>
                    <svg width="82" height="84" viewBox="0 0 81 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_72_1532)">
                        <path d="M40.275 43.7304C46.35 43.7304 51.075 38.1693 51.075 31.3443C51.075 24.5193 46.125 19.2109 40.05 19.2109C33.975 19.2109 29.25 24.772 29.25 31.3443C29.25 38.1693 34.2 43.7304 40.275 43.7304ZM40.05 24.2665C40.275 24.2665 40.275 24.2665 40.05 24.2665C43.65 24.2665 46.575 27.5526 46.575 31.597C46.575 35.6415 43.65 38.6748 40.05 38.6748C36.45 38.6748 33.75 35.3887 33.75 31.597C33.75 27.5526 36.675 24.2665 40.05 24.2665Z" fill="#8C73EE" />
                        <path d="M73.575 42.2135C69.3 37.9162 63.675 35.6412 57.825 35.894H56.025C55.575 37.9162 54.9 39.6857 54 41.2024C55.35 40.9496 56.475 40.9496 57.825 40.9496C62.1 40.6968 66.375 42.2135 69.75 44.994V63.194H74.25V42.9718L73.575 42.2135Z" fill="#8C73EE" />
                        <path d="M52.65 19.7164C53.775 16.683 56.925 15.1664 59.85 16.4303C62.55 17.6941 63.9 21.233 62.775 24.5191C61.875 26.7941 59.85 28.3108 57.825 28.3108C57.375 28.3108 56.7 28.3108 56.25 28.058C56.475 29.3219 56.475 30.5858 56.475 31.5969V33.1136C56.925 33.1136 57.375 33.3664 57.825 33.3664C63.45 33.3664 67.95 28.3108 67.95 22.2441C67.95 15.9247 63.45 10.8691 58.05 10.8691C54.45 10.8691 51.3 12.8914 49.5 16.4303C50.625 17.1886 51.75 18.1997 52.65 19.7164Z" fill="#8C73EE" />
                        <path d="M27 41.4553C26.1 39.9386 25.425 38.1692 24.975 36.147H23.175C17.325 35.8942 11.7 38.1692 7.425 42.2137L6.75 42.972V63.1942H11.25V44.9942C14.85 42.2136 18.9 40.697 23.175 40.9498C24.525 40.9498 25.875 41.2025 27 41.4553Z" fill="#8C73EE" />
                        <path d="M23.175 33.1136C23.625 33.1136 24.075 33.1136 24.525 32.8608V31.3441C24.525 30.0803 24.525 28.8164 24.75 27.8053C24.3 28.058 23.625 28.058 23.175 28.058C20.25 28.058 17.775 25.2775 17.775 21.9914C17.775 18.7053 20.25 15.9247 23.175 15.9247C25.425 15.9247 27.45 17.4414 28.35 19.7164C29.25 18.4525 30.6 17.1886 31.725 16.1775C28.8 10.8691 22.725 9.0997 18 12.3858C13.275 15.6719 11.7 22.4969 14.625 27.8053C16.425 31.0914 19.575 33.1136 23.175 33.1136Z" fill="#8C73EE" />
                        <path d="M58.725 57.381L58.275 56.6227C53.775 51.0616 47.475 47.7755 40.725 48.0282C33.975 47.7755 27.45 51.0616 22.95 56.6227L22.5 57.381V76.5921C22.5 78.8671 24.075 80.8894 26.325 80.8894H55.125C57.15 80.8894 58.95 78.8671 58.95 76.5921V57.381H58.725ZM54.225 75.8338H27V59.1505C30.6 55.106 35.55 53.0838 40.725 53.0838C45.675 52.831 50.625 55.106 54.225 59.1505V75.8338Z" fill="#8C73EE" />
                      </g>
                      <defs>
                        <clipPath id="clip0_72_1532">
                          <rect width="81" height="91" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                  </Center>
                  <Text
                    fontSize={'1.25rem'}
                    fontWeight={500}
                    color='blue'
                  >
                    {t('text-clients-count')}
                  </Text>
                  <Text
                    fontSize={'1.25rem'}
                    fontWeight={500}
                    color='blue'
                  >
                    {data.clientCount}
                  </Text>
                </VStack>




                <VStack>
                  <Center borderRadius={'5.125rem'} borderWidth={'0.2rem'} borderColor='blue' p={2}>
                    <svg width="82" height="84" viewBox="0 0 78 77" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M35.581 4.01074H42.419C45.3408 4.01074 47.775 4.01074 49.7055 4.26741C51.7465 4.53691 53.5893 5.13366 55.068 6.59345C56.55 8.05645 57.1545 9.87558 57.4275 11.8872C57.6875 13.7962 57.6875 16.2024 57.6875 19.0835V23.2607C59.5628 23.2607 61.1488 23.2768 62.4618 23.4083C63.999 23.5623 65.429 23.8992 66.716 24.7462C67.691 25.3911 68.5295 26.2188 69.1828 27.1845C70.0407 28.4518 70.382 29.8635 70.538 31.381C70.6875 32.8312 70.6875 34.6247 70.6875 36.771V68.1774H71.5C72.1465 68.1774 72.7665 68.4309 73.2236 68.8822C73.6807 69.3334 73.9375 69.9455 73.9375 70.5837C73.9375 71.2218 73.6807 71.8339 73.2236 72.2851C72.7665 72.7364 72.1465 72.9899 71.5 72.9899H6.5C5.85353 72.9899 5.23355 72.7364 4.77643 72.2851C4.31931 71.8339 4.0625 71.2218 4.0625 70.5837C4.0625 69.9455 4.31931 69.3334 4.77643 68.8822C5.23355 68.4309 5.85353 68.1774 6.5 68.1774H7.3125V36.7742C7.3125 34.6247 7.3125 32.8312 7.462 31.381C7.618 29.8635 7.95925 28.4518 8.81725 27.1813C9.4705 26.2188 10.309 25.3911 11.2873 24.7462C12.571 23.8992 14.001 23.5623 15.5382 23.4083C16.8513 23.2768 18.4373 23.264 20.3125 23.2607V19.0835C20.3125 16.2024 20.3125 13.7962 20.5725 11.8904C20.8455 9.87558 21.45 8.05645 22.9287 6.59666C24.4107 5.13366 26.2535 4.53691 28.2913 4.26741C30.225 4.01074 32.6625 4.01074 35.581 4.01074ZM20.3125 28.0732C18.4178 28.0732 17.082 28.0893 16.0323 28.1952C14.8785 28.3107 14.3455 28.516 13.9945 28.7502C13.5507 29.0429 13.1697 29.419 12.8733 29.8571C12.636 30.2036 12.428 30.7297 12.311 31.8687C12.1908 33.0462 12.1875 34.5958 12.1875 36.8962V68.1774H20.3125V28.0732ZM25.1875 68.1774H36.5625V60.9587C36.5625 60.3205 36.8193 59.7084 37.2764 59.2572C37.7335 58.8059 38.3535 58.5524 39 58.5524C39.6465 58.5524 40.2665 58.8059 40.7236 59.2572C41.1807 59.7084 41.4375 60.3205 41.4375 60.9587V68.1774H52.8125V19.2503C52.8125 16.1575 52.806 14.0785 52.5948 12.5289C52.3933 11.0498 52.0455 10.4146 51.6198 9.99749C51.1973 9.58041 50.557 9.23712 49.0588 9.03499C47.489 8.82966 45.383 8.82324 42.25 8.82324H35.75C32.617 8.82324 30.511 8.82966 28.9412 9.0382C27.443 9.23712 26.7995 9.58041 26.377 10.0007C25.9545 10.4178 25.6068 11.0498 25.402 12.5289C25.1973 14.0785 25.1875 16.1575 25.1875 19.2503V68.1774ZM57.6875 68.1774H65.8125V36.8962C65.8125 34.5926 65.8125 33.0462 65.689 31.8687C65.572 30.7297 65.364 30.2036 65.1267 29.8571C64.8312 29.4193 64.4514 29.0432 64.0088 28.7502C63.6545 28.516 63.1215 28.3107 61.9677 28.1952C60.918 28.0893 59.5822 28.0765 57.6875 28.0732V68.1774ZM30.0625 16.042C30.0625 15.4038 30.3193 14.7918 30.7764 14.3405C31.2335 13.8893 31.8535 13.6357 32.5 13.6357H45.5C46.1465 13.6357 46.7665 13.8893 47.2236 14.3405C47.6807 14.7918 47.9375 15.4038 47.9375 16.042C47.9375 16.6802 47.6807 17.2922 47.2236 17.7435C46.7665 18.1947 46.1465 18.4482 45.5 18.4482H32.5C31.8535 18.4482 31.2335 18.1947 30.7764 17.7435C30.3193 17.2922 30.0625 16.6802 30.0625 16.042ZM30.0625 25.667C30.0625 25.0288 30.3193 24.4168 30.7764 23.9655C31.2335 23.5143 31.8535 23.2607 32.5 23.2607H45.5C46.1465 23.2607 46.7665 23.5143 47.2236 23.9655C47.6807 24.4168 47.9375 25.0288 47.9375 25.667C47.9375 26.3052 47.6807 26.9172 47.2236 27.3685C46.7665 27.8197 46.1465 28.0732 45.5 28.0732H32.5C31.8535 28.0732 31.2335 27.8197 30.7764 27.3685C30.3193 26.9172 30.0625 26.3052 30.0625 25.667ZM30.0625 35.292C30.0625 34.6538 30.3193 34.0418 30.7764 33.5905C31.2335 33.1393 31.8535 32.8857 32.5 32.8857H45.5C46.1465 32.8857 46.7665 33.1393 47.2236 33.5905C47.6807 34.0418 47.9375 34.6538 47.9375 35.292C47.9375 35.9302 47.6807 36.5422 47.2236 36.9935C46.7665 37.4447 46.1465 37.6982 45.5 37.6982H32.5C31.8535 37.6982 31.2335 37.4447 30.7764 36.9935C30.3193 36.5422 30.0625 35.9302 30.0625 35.292ZM30.0625 44.917C30.0625 44.2788 30.3193 43.6668 30.7764 43.2155C31.2335 42.7643 31.8535 42.5107 32.5 42.5107H45.5C46.1465 42.5107 46.7665 42.7643 47.2236 43.2155C47.6807 43.6668 47.9375 44.2788 47.9375 44.917C47.9375 45.5552 47.6807 46.1672 47.2236 46.6185C46.7665 47.0697 46.1465 47.3232 45.5 47.3232H32.5C31.8535 47.3232 31.2335 47.0697 30.7764 46.6185C30.3193 46.1672 30.0625 45.5552 30.0625 44.917Z" fill="#8C73EE" />
                    </svg>

                  </Center>
                  <Text
                    fontSize={'1.25rem'}
                    fontWeight={500}
                    color='blue'
                  >
                    {t('text-projects-count')}
                  </Text>
                  <Text
                    fontSize={'1.25rem'}
                    fontWeight={500}
                    color='blue'
                  >
                    {data.projectCount}
                  </Text>
                </VStack>

                {/*<Card name={t('text-tasks-count')} count={data.taskCount} />
                <Card
                  name={t('text-completed-tasks-count')}
                  count={data.completedTaskCount}
                />*/}
              </Flex>
            </Stack>


            {data && (
              <VStack
                p={5}
                mb={5}
                boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)'
                bg='#fff' borderRadius={'1.25rem'}>
                <HStack display="flex" justifyContent={'space-between'} w="100%" mb={3}>
                  <Text fontSize={'1.50rem'}
                    fontWeight={1000} color='black'>
                    {t('text-Level-of-achievement')}
                  </Text>
                  {/* <Menu>
                    {({ isOpen }) => (
                      <>
                        <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline'>
                          {isOpen ? 'Close' : 'Open'}
                        </MenuButton>
                        <MenuList>
                          <MenuItem>Download</MenuItem>
                          <MenuItem onClick={() => alert('qwqwqq')}>Create a Copy</MenuItem>
                        </MenuList>
                      </>
                    )}
                  </Menu> */}
                </HStack>
                <HStack justifyContent={'center'} width="100%" height={400}>
                  <ResponsiveContainer>
                    <LineChart width={500} height={300} data={chart1Data}>
                      <XAxis dataKey="name" />
                      <Legend />
                      <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                      <Line type="monotone" dataKey="pv" stroke="#8884d8" />
                      <Line type="monotone" dataKey="amt" stroke="#82ca9d" />
                    </LineChart>
                  </ResponsiveContainer>
                </HStack>
              </VStack>
            )}

            <Grid
              // h={{base:'1000px',md:'900px',lg:'550px',xl:'550px'}}
              templateRows='repeat(1, 1fr)'
              templateColumns='repeat(2, 1fr)'
              gap={3}
              mb={4}
            >
              <GridItem colSpan={{ base: 2, md: 2, lg: 1, xl: 1 }} textAlign={'center'} w={{ base: '100%', md: '100%' }} h={{ base: '600px', md: '600px', lg: '550px', xl: '550px' }}
                boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)' p={5} bg='#fff' borderRadius={'1.25rem'}>
                <Text
                  fontSize={'1.50rem'}
                  fontWeight={1000} color='black'
                  py={2}
                  mb='3.5rem'
                >
                  {t('text-Warehouse-statistics')}
                </Text>
                <Stack position={{ lg: 'relative', xl: 'relative' }} alignItems={'center'}>

                  <Box position={{ lg: 'absolute', xl: 'absolute' }} bg='#FFF' borderRadius={'50%'} w="200px" h="200px" top={{ lg: '95', xl: '35' }} right={{ lg: '0', xl: '90' }}>
                    <CircularProgress value={40} color="#9fb9fb" size='200px'>
                      <CircularProgressLabel>
                        <Text
                          fontSize={'0.80rem'}
                          fontWeight={800} color='#9fb9fb'
                        >
                          {t('text-materials-in-store-count')}
                        </Text>
                        <Text
                          fontSize={'0.80rem'}
                          fontWeight={800} color='#9fb9fb'
                        >
                          40%
                        </Text>
                      </CircularProgressLabel>
                    </CircularProgress>
                    {/* <Box position="absolute" bg='#9fb9fb' p='6' borderRadius={'50%'} w="138px" h="138px" top="5px" right="5px">
                </Box> */}
                  </Box>
                  <Box position={{ lg: 'absolute', xl: 'absolute' }} bg='#FFF' borderRadius={'50%'} w="140px" h="140px" top={{ lg: '0', xl: '-20' }} right={{ lg: '180', xl: '240' }}>
                    <CircularProgress value={80} color="#b7a1e2" size='140px'>
                      <CircularProgressLabel>
                        <Text
                          fontSize={'0.80rem'}
                          fontWeight={800} color='#b7a1e2'
                        >
                          {t('text-retreived-not-custodays-count')}
                        </Text>
                        <Text
                          fontSize={'0.80rem'}
                          fontWeight={800} color='#b7a1e2'
                        >
                          80%
                        </Text>
                      </CircularProgressLabel>
                    </CircularProgress>
                    {/* <Box position="absolute" bg='#b7a1e2' p='6' borderRadius={'50%'} w="30px" h="30px" top="5px" right="5px"></Box> */}
                  </Box>
                  <Box position={{ lg: 'absolute', xl: 'absolute' }} bg='#FFF' borderRadius={'50%'} w="140px" h="140px" top={{ lg: '210', xl: '150' }} right={{ lg: '180', xl: '270' }}
                    textAlign={'center'}>
                    <CircularProgress value={60} color="#7290fd" size='140px'>
                      <CircularProgressLabel>
                        <Text
                          fontSize={'0.80rem'}
                          fontWeight={800} color='#7290fd'
                        >
                          {t('text-retreived-custodays-count')}
                        </Text>
                        <Text
                          fontSize={'0.80rem'}
                          fontWeight={800} color='#7290fd'
                        >
                          60%
                        </Text>
                      </CircularProgressLabel>
                    </CircularProgress>
                    {/* <Box position="absolute" bg='#7290fd' p='6' borderRadius={'50%'} w="30px" h="30px" top="5px" right="5px"></Box> */}
                  </Box>
                </Stack>
              </GridItem>


              <GridItem colSpan={{ base: 2, md: 2, lg: 1, xl: 1 }} h={{ base: '500px', md: '500px', lg: '550px', xl: '550px' }}
                boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)' p={5} bg='#fff' borderRadius={'1.25rem'}>

                <HStack display="flex" justifyContent={'space-around'} justifyItems='Center' w="100%" mb={3} >
                  <Text
                    fontSize={'1.50rem'}
                    fontWeight={1000} color='black'
                    py={2}
                  >
                    {t('text-Staff-achievement')}
                  </Text>
                  <HStack display="flex">
                    <Menu>
                      {({ isOpen }) => (
                        <>

                          <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline'>
                            {t('text-month')}
                          </MenuButton>
                          <MenuList>
                            <MenuItem></MenuItem>
                            {data2.map((entry, index) => (
                              <MenuItem value={entry.value} onClick={async () => {
                                debugger;

                                cdID = await usersCompletedTasks(entry.value);
                                setcdID(cdID);
                                //cdID=await b


                              }
                              }>{entry.name}</MenuItem>
                            ))}
                          </MenuList>
                        </>
                      )}
                    </Menu>

                    {/* <Menu>
                      {({ isOpen }) => (
                        <>
                          <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline'>
                            {t('text-year')}
                          </MenuButton>
                          <MenuList>
                            <MenuItem>Download</MenuItem>
                            <MenuItem onClick={() => alert('Kagebunshin')}>Create a Copy</MenuItem>
                          </MenuList>
                        </>
                      )}
                    </Menu> */}
                  </HStack>
                </HStack>
                <Stack display={'flex'} justifyContent={'space-between'} mb={5}>
                  <Stack display={'flex'} justifyContent={'space-around'} mt={7}>
                    <Box bg='#FFF' borderRadius={'50%'} w="200px" h="200px"
                      alignSelf={'center'}>
                      <CircularProgress value={60} color="#94b1fb" size='200px'>
                        <CircularProgressLabel>
                          <CircularProgress value={60} color="#60d669" size='140px'>
                            <CircularProgressLabel>
                              <CircularProgress value={50} color="#ff7070" size='90px'>
                                <CircularProgressLabel>

                                </CircularProgressLabel>
                              </CircularProgress>
                            </CircularProgressLabel>
                          </CircularProgress>
                        </CircularProgressLabel>
                      </CircularProgress>
                    </Box>
                    <List spacing={3} display={'flex'} alignItems={'end'} justifyContent={'space-around'}>
                      <ListItem display={'flex'} alignItems={'center'}>
                        <ListIcon as={MdCheckCircle} color='#94b1fb' fontSize={30} />
                        <VStack>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            {t('text-taskCompletionRate')}
                          </Text>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            40%
                            {/* {setcdID} % */}
                          </Text>
                        </VStack>
                      </ListItem>
                      <ListItem display={'flex'} alignItems={'center'}>
                        <ListIcon as={MdCheckCircle} color='#60d669' fontSize={30} />
                        <VStack>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            {t('text-present-percentage')}
                          </Text>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            80%
                          </Text>
                        </VStack>
                      </ListItem>
                      <ListItem display={'flex'} alignItems={'center'}>
                        <ListIcon as={MdCheckCircle} color='#ff7070' fontSize={30} />
                        <VStack>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            {t('text-absence-percentage')}
                          </Text>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            80%
                          </Text>
                        </VStack>
                      </ListItem>
                    </List>
                  </Stack>
                </Stack>
              </GridItem>
            </Grid>
            <Text
              fontSize={'1.50rem'}
              fontWeight={1000} color='dark'
              px={2}
              mb='1.5rem'
            >{t('text-Branch-statistics')}</Text>
            




            {/* //************************* */}


            {/* <Grid
              templateRows='repeat(1, 1fr)'
              templateColumns='repeat(3, 1fr)'
              gap={3}
              mb='3.5rem'
              alignItems={'center'}
            > */}
            <Stack display={'flex'} justifyContent={'space-evenly'} alignItems={'center'} flexDirection={'row'} gap={3}
              mb='3.5rem' flexWrap={'wrap'}>
            <GridItem colSpan={{ base: 3, md: 3, lg: 3, xl: 1 }} pt={6}
                boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)' p={5}
                bg='#fff' borderRadius={'1.25rem'}>
                <Menu>
                  {({ isOpen }) => (
                    <>
                      <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline' w={'100%'} mb='1.5rem'>
                        {t('text-branch')}
                      </MenuButton>
                      <MenuList>
                        
                        
                        <MenuItem>{branch?.bramchName}</MenuItem>
                      </MenuList>
                    </>
                  )}
                </Menu>
                <Stack gap={3} display={'flex'} flexDirection={{ base: 'column', md: 'column', lg: 'row', xl: 'row' }} minHeight={'325px'}>
                  <VStack alignSelf={{ base: 'center', md: 'center' }}>
                    <HStack gap={3} mb={3} alignSelf={'flex-start'} w={150}>
                      <svg width="52" height="64" viewBox="0 0 52 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.5476 35.311C33.8319 35.311 40.5476 27.9306 40.5476 18.8264C40.5476 9.7222 33.8319 2.3418 25.5476 2.3418C17.2633 2.3418 10.5476 9.7222 10.5476 18.8264C10.5476 27.9306 17.2633 35.311 25.5476 35.311Z" stroke="#6284FD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M49.5479 61.6869C49.5479 54.6917 47.0193 47.983 42.5184 43.0367C38.0175 38.0903 31.913 35.3115 25.5479 35.3115C19.1827 35.3115 13.0782 38.0903 8.57729 43.0367C4.07642 47.983 1.54785 54.6917 1.54785 61.6869" stroke="#6284FD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <VStack textAlign={'center'} w={'inherit'}>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {t('text-empoyees-count')}
                        </Text>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {data.branchUserCount}
                        </Text>
                      </VStack>
                    </HStack>
                    <HStack gap={3} mb={3} alignSelf={'flex-start'} w={150}>
                      <svg width="52" height="63" viewBox="0 0 52 63" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M47.6864 42.9056C46.1585 47.3742 43.7686 51.3119 40.7258 54.3744C37.683 57.4369 34.0799 59.531 30.2315 60.4736C26.383 61.4162 22.4065 61.1786 18.6495 59.7816C14.8924 58.3846 11.4694 55.8707 8.67945 52.4597C5.88955 49.0487 3.81779 44.8444 2.6453 40.2144C1.47281 35.5845 1.23529 30.6698 1.95351 25.9001C2.67172 21.1304 4.3238 16.6509 6.76531 12.8532C9.20682 9.05556 12.3634 6.05533 15.9591 4.11484M47.7556 19.9851C48.717 22.8557 49.3068 25.8904 49.507 28.9779C49.5564 29.7406 49.5812 30.122 49.4587 30.4655C49.3564 30.7525 49.1537 31.0241 48.9306 31.1731C48.6634 31.3515 48.3298 31.3515 47.6624 31.3515H27.4876C26.815 31.3515 26.4788 31.3515 26.2219 31.1897C25.9959 31.0473 25.8122 30.8201 25.6971 30.5407C25.5662 30.223 25.5662 29.8071 25.5662 28.9754V4.02574C25.5662 3.20042 25.5662 2.78776 25.7105 2.45742C25.831 2.18148 26.0506 1.93083 26.2826 1.80431C26.5604 1.65285 26.8688 1.68343 27.4856 1.74458C29.9821 1.99211 32.4361 2.72147 34.7573 3.91051C37.6713 5.40317 40.319 7.591 42.5492 10.3491C44.7794 13.1072 46.5486 16.3815 47.7556 19.9851Z" stroke="#6284FD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <VStack textAlign={'center'} w={'inherit'}>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {t('text-departments-count')}
                        </Text>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {data.branchDepartmentCount}
                        </Text>
                      </VStack>
                    </HStack>
                    <HStack gap={3} mb={3} alignSelf={'flex-start'} w={150}>
                      <svg width="49" height="54" viewBox="0 0 49 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M41.9397 48.9375V1.6875H7.4397V48.9375H2.1897V52.3125H47.1897V48.9375H41.9397ZM38.9397 48.9375H26.1897V42.1875H23.1897V48.9375H10.4397V5.0625H38.9397V48.9375Z" fill="#6284FD" />
                        <path d="M15.6897 32.0625H18.6897V35.4375H15.6897V32.0625ZM23.1897 32.0625H26.1897V35.4375H23.1897V32.0625ZM30.6897 32.0625H33.6897V35.4375H30.6897V32.0625ZM15.6897 21.9375H18.6897V25.3125H15.6897V21.9375ZM23.1897 21.9375H26.1897V25.3125H23.1897V21.9375ZM30.6897 21.9375H33.6897V25.3125H30.6897V21.9375ZM15.6897 11.8125H18.6897V15.1875H15.6897V11.8125ZM23.1897 11.8125H26.1897V15.1875H23.1897V11.8125ZM30.6897 11.8125H33.6897V15.1875H30.6897V11.8125Z" fill="#6284FD" />
                      </svg>
                      <VStack textAlign={'center'} w={'inherit'}>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {t('text-projects-count')}
                        </Text>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {data.branchProjectCount}
                        </Text>
                      </VStack>
                    </HStack>
                  </VStack>


                  <VStack alignSelf={{ base: 'center', md: 'center' }}>
                    <HStack gap={3} mb={3} alignSelf={'flex-start'} w={150}>
                      <svg width="44" height="59" viewBox="0 0 44 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.8413 32.1137H29.8413M14.8413 43.1036H22.3413M2.34131 7.38653V51.346C2.34131 52.8033 2.86809 54.201 3.80577 55.2315C4.74346 56.262 6.01523 56.8409 7.34131 56.8409H37.3413C38.6674 56.8409 39.9391 56.262 40.8768 55.2315C41.8145 54.201 42.3413 52.8033 42.3413 51.346V19.316C42.3412 18.584 42.208 17.8594 41.9496 17.1847C41.6911 16.51 41.3126 15.8988 40.8363 15.3872L29.7363 3.45766C28.8022 2.45389 27.5477 1.89178 26.2413 1.8916H7.34131C6.01523 1.8916 4.74346 2.47053 3.80577 3.50103C2.86809 4.53153 2.34131 5.92919 2.34131 7.38653Z" stroke="#6284FD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M27.3409 1.8916V12.8815C27.3409 14.3388 27.8677 15.7365 28.8054 16.767C29.7431 17.7975 31.0149 18.3764 32.3409 18.3764H42.3409" stroke="#6284FD" stroke-width="3" stroke-linejoin="round" />
                      </svg>
                      <VStack textAlign={'center'} w={'inherit'}>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {t('text-completed-projects-count')}
                        </Text>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {data.branchCopletedTaskCount}
                        </Text>
                      </VStack>
                    </HStack>
                    <HStack gap={3} mb={3} alignSelf={'flex-start'} w={150}>
                      <svg width="48" height="60" viewBox="0 0 48 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M43.6364 53.0922H48V59.6861H0V53.0922H4.36364V3.63778C4.36364 2.76337 4.59351 1.92478 5.00268 1.30648C5.41185 0.688177 5.9668 0.34082 6.54545 0.34082H28.3636C28.9423 0.34082 29.4972 0.688177 29.9064 1.30648C30.3156 1.92478 30.5455 2.76337 30.5455 3.63778V53.0922H39.2727V26.7165H34.9091V20.1226H41.4545C42.0332 20.1226 42.5882 20.4699 42.9973 21.0882C43.4065 21.7065 43.6364 22.5451 43.6364 23.4195V53.0922ZM8.72727 6.93474V53.0922H26.1818V6.93474H8.72727ZM13.0909 26.7165H21.8182V33.3104H13.0909V26.7165ZM13.0909 13.5287H21.8182V20.1226H13.0909V13.5287Z" fill="#6284FD" />
                      </svg>
                      <VStack textAlign={'center'} w={'inherit'}>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {t('text-tasks-count')}
                        </Text>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {data.branchTaskrCount}
                        </Text>
                      </VStack>
                    </HStack>
                    <HStack gap={3} mb={3} alignSelf={'flex-start'} w={150}>
                      <svg width="41" height="56" viewBox="0 0 41 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.3415 51.9824H4.34173V4.88358H20.3415V16.6583C20.3446 17.6983 20.7671 18.6948 21.5165 19.4302C22.266 20.1656 23.2815 20.5801 24.3414 20.5832H36.3412V32.3579H40.3411V16.6583C40.3482 16.4004 40.2982 16.144 40.1946 15.9069C40.0911 15.6697 39.9364 15.4574 39.7412 15.2846L25.7414 1.54741C25.5653 1.35577 25.349 1.20388 25.1073 1.10224C24.8656 1.0006 24.6043 0.951618 24.3414 0.958675H4.34173C3.28186 0.961781 2.2663 1.37629 1.51685 2.11168C0.767399 2.84707 0.344962 3.84359 0.341797 4.88358V51.9824C0.344962 53.0224 0.767399 54.0189 1.51685 54.7543C2.2663 55.4897 3.28186 55.9042 4.34173 55.9073H18.3415V51.9824ZM24.3414 5.66856L35.5412 16.6583H24.3414V5.66856Z" fill="#6284FD" />
                      </svg>
                      <VStack textAlign={'center'} w={'inherit'}>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {t('text-completed-tasks-count')}
                        </Text>
                        <Text
                          fontSize={'1rem'}
                          fontWeight={1000} color='blue'>
                          {data.branchCopletedTaskCount}
                        </Text>
                      </VStack>
                    </HStack>
                  </VStack>
                </Stack>

              </GridItem>



              <GridItem colSpan={{ base: 3, md: 3, lg: 1, xl: 1 }}
                boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)' p={5} bg='#fff' borderRadius={'1.25rem'}>
                <Stack>

                </Stack>
                <Menu>
                  {({ isOpen }) => (
                    <>
                      <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline' w={'100%'} mb={3}>
                        {t('text-dept')}
                      </MenuButton>
                      <MenuList>
                        
                        <MenuItem>{t('text-all')}</MenuItem>
                     
                        {departmentsQuery.data?.map((item) => (
                          
                          <MenuItem>  
                          {item.departmentName}
                           </MenuItem>
                        ))}
                        
                        {/* <MenuItem onClick={() => alert('Kagebunshin')}>{t('text-marketing')}</MenuItem> */}
                      </MenuList>
                    </>
                  )}
                </Menu>
                <HStack display={'flex'} justifyContent={'center'}>
                  <Text
                    fontSize={'1.5rem'}
                    fontWeight={1000} color='blue' textAlign={'center'}>
                    {t('text-projects')}
                  </Text>
                </HStack>

                <VStack textAlign={'center'}>



                  <Stack >
                    <Box bg='#FFF' borderRadius={'50%'} w="200px" h="200px"
                      alignSelf={'center'}>
                      <CircularProgress value={60} color="#94b1fb" size='200px'>
                        <CircularProgressLabel>
                          <CircularProgress value={60} color="#60d669" size='140px'>
                            <CircularProgressLabel>

                            </CircularProgressLabel>
                          </CircularProgress>
                        </CircularProgressLabel>
                      </CircularProgress>
                    </Box>
                    <List spacing={3} display={'flex'} alignItems={'end'} justifyContent={'space-between'} gap={3}>
                      <ListItem display={'flex'} alignItems={'center'} >
                        <ListIcon as={MdCheckCircle} color='#94b1fb' fontSize={30} />
                        <VStack>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            {t('text-projects-count')}
                          </Text>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            40%
                          </Text>
                        </VStack>
                      </ListItem>
                      <ListItem display={'flex'} alignItems={'center'} >
                        <ListIcon as={MdCheckCircle} color='#60d669' fontSize={30} />
                        <VStack>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            {t('text-new-projects')}
                          </Text>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            80%
                          </Text>
                        </VStack>
                      </ListItem>
                    </List>
                  </Stack>
                </VStack>
              </GridItem>

              <GridItem colSpan={{ base: 3, md: 3, lg: 1, xl: 1 }}
                boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)' p={5}
                bg='#fff' borderRadius={'1.25rem'}>
                <Stack display={'flex'} alignItems={'end'} gap={4} justifyContent={'space-between'} flexDirection={'row'} mb={3}>
                  {/* <Menu>
                    {({ isOpen }) => (
                      <>
                        <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline' w={'50%'}>
                          {t('text-month')}
                        </MenuButton>
                        <MenuList>
                          <MenuItem>Download</MenuItem>
                          <MenuItem onClick={() => alert('Kagebunshin')}>Create a Copy</MenuItem>
                        </MenuList>
                      </>
                    )}
                  </Menu>
                  <Menu>
                    {({ isOpen }) => (
                      <>
                        <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline' w={'50%'}>
                          {t('text-year')}
                        </MenuButton>
                        <MenuList>
                          <MenuItem>Download</MenuItem>
                          <MenuItem onClick={() => alert('Kagebunshin')}>Create a Copy</MenuItem>
                        </MenuList>
                      </>
                    )}
                  </Menu> */}
                </Stack>
                <HStack display={'flex'} justifyContent={'center'}>
                  <Text
                    fontSize={'1.5rem'}
                    fontWeight={1000} color='blue' textAlign={'center'}>
                    {t('text-tasks')}
                  </Text>
                </HStack>

                <VStack textAlign={'center'}>
                  <Stack >
                    <Box bg='#FFF' borderRadius={'50%'} w="200px" h="200px"
                      alignSelf={'center'}>
                      <CircularProgress value={60} color="#94b1fb" size='200px'>
                        <CircularProgressLabel>
                          <CircularProgress value={60} color="#60d669" size='140px'>
                            <CircularProgressLabel>

                            </CircularProgressLabel>
                          </CircularProgress>
                        </CircularProgressLabel>
                      </CircularProgress>
                    </Box>
                    <List spacing={3} display={'flex'} alignItems={'end'} justifyContent={'space-between'} gap={3}>
                      <ListItem display={'flex'} alignItems={'center'}>
                        <ListIcon as={MdCheckCircle} color='#94b1fb' fontSize={30} />
                        <VStack>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            {t('text-tastsCount')}
                          </Text>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            40%
                          </Text>
                        </VStack>
                      </ListItem>
                      <ListItem display={'flex'} alignItems={'center'} mt={0}>
                        <ListIcon as={MdCheckCircle} color='#60d669' fontSize={30} />
                        <VStack>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            {t('text-current-tasks')}
                          </Text>
                          <Text
                            fontSize={'1rem'}
                            fontWeight={600} color='black'
                          >
                            80%
                          </Text>
                        </VStack>
                      </ListItem>
                    </List>
                  </Stack>
                </VStack>
              </GridItem>
            </Stack>
              


            {/* </Grid> */}



            {/* /********************* */}
            <Grid overflow={'scroll'} boxShadow='0px 12px 16px -4px rgba(0, 0, 0, 0.08), 0px 4px 6px -2px rgba(0, 0, 0, 0.03)' p={5} bg='#fff' borderRadius={'1.25rem'}>
              {data && (
                <VStack
                  pb={4}
                  mb={5}>

                  <HStack display="flex" justifyContent={'space-between'} w="100%" mb={3}>
                    <Text fontSize={'1.50rem'}
                      fontWeight={1000} color='dark'>
                      {t('text-Level-of-achievement')}
                    </Text>
                    <HStack>
                      {/* <Menu>
                        {({ isOpen }) => (
                          <>
                            <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline'>
                              {t('text-month')}
                            </MenuButton>
                            <MenuList>
                              <MenuItem>Download</MenuItem>
                              <MenuItem onClick={() => alert('Kagebunshin')}>Create a Copy</MenuItem>
                            </MenuList>
                          </>
                        )}
                      </Menu>
                      <Menu>
                        {({ isOpen }) => (
                          <>
                            <MenuButton isActive={isOpen} as={Button} rightIcon={<ChevronDownIcon />} colorScheme='blue' variant='outline'>
                              {t('text-year')}
                            </MenuButton>
                            <MenuList>
                              <MenuItem>Download</MenuItem>
                              <MenuItem onClick={() => alert('eterter')}>Create a Copy</MenuItem>
                            </MenuList>
                          </>
                        )}
                      </Menu> */}
                    </HStack>
                  </HStack>
                  <HStack justifyContent={'center'} width="100%" height={400}>
                    <ResponsiveContainer >
                      <ComposedChart width={730} height={250} data={chart1DataDept}>
                        <XAxis dataKey="name" />
                        <YAxis dataKey="pv"></YAxis>
                        <Tooltip />
                        <Legend />
                        <CartesianGrid stroke="#f5f5f5" />
                        <Bar dataKey="pv" barSize={20} fill="#413ea0" />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </HStack>
                </VStack>
              )}
            </Grid>
          </Box>
          <Box>
            <EventsCalendar date={date} setDate={setDate} />
          </Box>
        </Stack>
      )}
    </MainContainer>
  );
};

export default AdminDashboard;

interface CardProps {
  name?: string;
  count?: string | number;
}

const Card: React.FC<CardProps> = ({ name, count }) => {
  return (
    <VStack>

      <Text color='rgba(0, 0, 0, 0.46)' mb={0}>
        {name}
      </Text>
      <Text
      >
        {count}
      </Text>
    </VStack>
  );
};

interface SemiCircleProps {
  name: string;
  value: string | number;
}

const SemiCircle: React.FC<SemiCircleProps> = ({ name, value }) => {
  return (
    <HStack>
      <svg
        width='18.75rem'
        height='15.125rem'
        viewBox='0 0 300 121'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M300 121C300 105.11 296.12 89.3757 288.582 74.6953C281.044 60.0149 269.995 46.676 256.066 35.4401C242.137 24.2042 225.601 15.2914 207.403 9.21058C189.204 3.12976 169.698 -6.94572e-07 150 0C130.302 6.94572e-07 110.796 3.12976 92.5975 9.21058C74.3986 15.2914 57.8628 24.2042 43.934 35.4401C30.0052 46.676 18.9563 60.0149 11.4181 74.6953C3.87986 89.3757 -1.72208e-06 105.11 0 121H62.8791C62.8791 111.771 65.1326 102.632 69.5108 94.106C73.8891 85.5795 80.3063 77.8322 88.3962 71.3063C96.4862 64.7804 106.09 59.6038 116.66 56.0721C127.23 52.5403 138.559 50.7225 150 50.7225C161.441 50.7225 172.77 52.5403 183.34 56.0721C193.91 59.6038 203.514 64.7804 211.604 71.3063C219.694 77.8322 226.111 85.5795 230.489 94.106C234.867 102.632 237.121 111.771 237.121 121H300Z'
          fill='url(#paint0_linear_322_1161)'
        />
        <defs>
          <linearGradient
            id='paint0_linear_322_1161'
            x1='194.5'
            y1='2.19866e-06'
            x2='150'
            y2='242'
            gradientUnits='userSpaceOnUse'
          >
            <stop stop-color='#8183B7' />
            <stop offset='0.741833' stop-color='#B6CAE1' stop-opacity='0' />
          </linearGradient>
        </defs>
        <text
          x='120'
          y='110'
          font-family='Arial'
          font-size='2.5rem'
          fill='black'
        >
          {value}%
        </text>
      </svg>
      <Text color={'rgba(0, 0, 0, 0.50)'} fontSize={'1.25rem'} fontWeight={500}>
        {name}
      </Text>
    </HStack>
  );
};
